import { createFileRoute } from '@tanstack/react-router';
import { PricingPage } from '@/features/pricing/PricingPage.tsx';

export const Route = createFileRoute('/_app/pricing')({
  component: PricingPage,
});
